import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { UtilsService } from '@core/services/utils/utils.service';
import { Store } from '@ngrx/store';
import { AppState } from '@core/store/app.reducer';
import * as ShoppingActions from '@core/store/shoppingCar/shoppingCar.actions';
import { LocalStorageService } from '@core/services/local-storage.service';
import { GtmEventService } from '@core/analytics/gtm-events.service';

@Component({
  selector: 'app-essentials-card',
  templateUrl: './essentials-card.component.html',
  styleUrls: ['./essentials-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class InfaltablesCardComponent implements OnInit {
  @Input() cardData: any;
  @Input() discountedPriceLoading: boolean = false;
  @Input() listData?: any = 'general';
  @Input() listIdData?: any = 'GENERAL';
  localCardData: any;
  readonly carsState: any = { cars: [] };
  sectorSelect: any;

  constructor(
    private readonly store: Store<AppState>,
    private readonly _gtmEventService: GtmEventService,
    private readonly _localStorageService: LocalStorageService
  ) {}

  ngOnInit() {
    this.getUnits();
    this.initStore();
    this.localCardData = {
      count: this.cardData.count ,
      totalPrice: this.cardData.totalPrice || '0',
      sku: this.cardData?.sku ? Number(this.cardData.sku) : null
    };
  
  }

  // Getter para seleccionar la imagen según el descuento
  get discountImageUrl(): string {
    if (this.cardData && this.cardData.discountType === 'PRECIO') {
      return 'assets/image/infaltables-card/discount-fund_green.svg';
    }
    return 'assets/image/infaltables-card/discount-fund.svg';
  }
  get discountText(): string {
    if (this.cardData && this.cardData.discountType === 'PRECIO') {
      return 'Desct.';
    }
    return 'Rebate';
  }

  getUnits() {
    if(this._localStorageService.getItem('sectorSelect').name){
      this.sectorSelect = this._localStorageService.getItem('sectorSelect')
    } else {
      this.sectorSelect = this._localStorageService.getItem('clientSelect')
    }
  }

  clickCount(e: any) {
    if (this.localCardData.count === 0) {
      this.localCardData.count = '';
    }
  }

  mouseUp(e: any) {
    if (this.localCardData.count === 0 || this.localCardData.count === '') {
      this.localCardData.count = 0;
    }
  }

  updateCount(value: number) {
      const replace = String(value).replace(/[^0-9-.]/g, '');
      let countFormat = Number.parseFloat(replace);
      
      if (Number.isNaN(countFormat) || countFormat == 0) {
        this.localCardData.totalPrice = '0';
        this.localCardData.count = '';
      } else if (countFormat < 0) {
        countFormat = countFormat * -1;
        const total = countFormat * Number.parseFloat(this.cardData.discountedPrice || this.cardData.originalPrice);
        this.localCardData.totalPrice = UtilsService.formatTotalNumber(total.toFixed(2));
        this.localCardData.count = UtilsService.formatNumber(countFormat);
      } else if (countFormat > 999999) {
        const total = 999999 * Number.parseFloat(this.cardData.discountedPrice || this.cardData.originalPrice);
        this.localCardData.totalPrice = UtilsService.formatTotalNumber(total.toFixed(2));
        this.localCardData.count = '999,999';
      } else {
        const total = countFormat * Number.parseFloat(this.cardData.discountedPrice || this.cardData.originalPrice);
        this.localCardData.totalPrice = UtilsService.formatTotalNumber(total.toFixed(2));
        this.localCardData.count = UtilsService.formatNumber(countFormat);
      }
    }

    get totalPrice(): string {
      if (!this.localCardData?.totalPrice) {
        return '0';
      }
      return this.localCardData.totalPrice;
    }

  initStore() {
    this.store.select('carsState').subscribe(carsState => {
      if (carsState) {
        this.carsState.cars = [...carsState.cars];
      }
    });
  }

  addToCar() {
    if (!this.localCardData.count || this.localCardData.count === '0') return;
    
    const productToAdd = {
      available: this.cardData.available,
      baseUnd: this.cardData.baseUnd,
      brandName: this.cardData.brandName,
      buyUnd: this.cardData.buyUnd,
      cashPrice: this.cardData.cashPrice,
      categoryName: this.cardData.categoryName,
      count: this.localCardData.count,
      creditPrice: this.cardData.creditPrice,
      description: this.cardData.description,
      igv: this.cardData.igv?.toString(),
      percep: this.cardData.percep,
      perceptionFlag: this.cardData.perceptionFlag,
      salePrice: this.cardData.salePrice,
      sku: this.localCardData.sku,
      stock: this.cardData.stock,
      suggestedQuantity: this.cardData.suggestedQuantity,
      totalPrice: this.localCardData.totalPrice,
      url: this.cardData.productImage,
      discount: this.cardData.discountNumber,
      discountType: this.cardData.discountType,
      discountedPrice: null,
      categoryCode: this.cardData.categoryCode,
      group: this.cardData.group,
      isWebExclusive: this.cardData.isWebExclusive,
      mechanics: this.cardData.mechanics,
      priority: this.cardData.priority,
      item_list_name: this.listData,
      item_list_id: this.listIdData,
      isEssential: true
    };

    if (this.carsState.cars.length == 0) {
      // crear carro nuevo
      const car = {
        unitBussines: this.sectorSelect.name,
        products: [productToAdd]
      };
      this.carsState.cars.push(car);
      this.store.dispatch(ShoppingActions.setCar({ cars: this.carsState.cars }));
    } else {
      // buscar la unidad de negocio actual
      let ifBusinessCarExist = false;
      const tempCars = this.carsState.cars.map(car => {
        if (car.unitBussines == this.sectorSelect.name) {
          car = {
            ...car,
            products: this.searchProductInExistingCar(car, productToAdd)
          };
          ifBusinessCarExist = true;
          return car;
        }
        return car;
      });

      if (!ifBusinessCarExist) {
        const car = {
          unitBussines: this.sectorSelect.name,
          products: [productToAdd]
        };
        tempCars.push(car);
      }
      this.carsState.cars = [...tempCars];
      this.store.dispatch(ShoppingActions.setCar({ cars: this.carsState.cars }));
    }
    // console.log(productToAdd);
    
    // Crear los campos de precio específicos para el producto
    const priceFields = [{
      price: productToAdd.discountedPrice 
        ? this.currentToNumber(productToAdd.discountedPrice)
        : this.currentToNumber(productToAdd.salePrice) || this.currentToNumber(productToAdd.cashPrice),
      totalPrice: productToAdd.discountedPrice 
        ? Number.parseFloat((this.currentToNumber(productToAdd.discountedPrice) * this.currentToNumber(productToAdd.count)).toFixed(2))
        : Number.parseFloat((this.currentToNumber(productToAdd.salePrice) * this.currentToNumber(productToAdd.count)).toFixed(2)),
      discount: productToAdd.discountedPrice 
        ? Number.parseFloat((this.currentToNumber(productToAdd.salePrice) - this.currentToNumber(productToAdd.discountedPrice)).toFixed(2))
        : 0
    }];
    
    this._gtmEventService.addProductCartEvent("Añadir", [productToAdd], priceFields);
    this.cleanCar();
  }

  currentToNumber(current) {
    if (current) {
      if (typeof current === 'string') {
        return Number(current.replace(/,/g, ''));
      } else if (typeof current === 'number') {
        return current;
      } else {
        throw new Error('Invalid input type');
      }
    } else {
      return 0;
    }
  }

  searchProductInExistingCar(car: any, productToAdd: any) {
    let newListInCarProducts: any = [];
    let flagExist = false;
    
    car.products.forEach((productInCar) => {
      if (productToAdd.sku == productInCar.sku) {
        const replace = Number.isInteger(productToAdd.count) ? productToAdd.count : productToAdd.count.replace(/[^0-9]/g, '');
        const replace2 = Number.isInteger(productInCar.count) ? productInCar.count : productInCar.count.replace(/[^0-9]/g, '');
        
        let tempCount = Number.parseFloat(replace) + Number.parseFloat(replace2) > 999999
          ? 999999
          : Number.parseFloat(replace) + Number.parseFloat(replace2);
        let tempTotalprice = UtilsService.formatTotalNumber((tempCount * Number.parseFloat(productInCar.salePrice)).toFixed(2));
        
        newListInCarProducts.push({
          ...productInCar,
          count: UtilsService.formatNumber(tempCount),
          totalPrice: `${tempTotalprice}`
        });
        flagExist = true;
      } else {
        newListInCarProducts.push(productInCar);
      }
    });

    if (!flagExist) {
      newListInCarProducts.push(productToAdd);
    }
    
    return newListInCarProducts;
  }

  private calculateNewCount(existingCount: string | number, newCount: string | number): string {
    const count1 = Number.isInteger(existingCount) ? existingCount : existingCount.toString().replace(/[^0-9]/g, '');
    const count2 = Number.isInteger(newCount) ? newCount : newCount.toString().replace(/[^0-9]/g, '');
    
    let total = Number.parseFloat(count1.toString()) + Number.parseFloat(count2.toString());
    total = total > 999999 ? 999999 : total;
    
    return UtilsService.formatNumber(total);
  }

  cleanCar() {
    this.localCardData.count = 0;
    this.localCardData.totalPrice = '0';
  }
}
